import { cn } from "@omni/utils/styles";

import { useDeliveryItemContext } from "@/components/Product/ECommerce/components/delivery/components/deliveryTypes/deliveryItem/context/deliveryItem.context";
import Stock from "@/components/Store/StoreDetails/stock.component";
import { useGranite } from "@/redux/modules/value/translations/translations.provider";

type Props = {
    className?: string;
};

export const ItemStock = ({ className }: Props) => {
    const { t } = useGranite();

    const { isBoxArticle, preferredStore } = useDeliveryItemContext();

    const shopName = preferredStore?.shopName;
    const productAvailability = preferredStore?.productAvailability;

    if (isBoxArticle || !productAvailability) return null;

    return (
        <div className={cn(className)}>
            {shopName && (
                <div className={cn("tw:text-sm tw:font-bold")}>
                    {t("ecommerce.label.pickup.preferredStore", shopName)}
                </div>
            )}
            <div className={cn("tw:text-sm")}>
                <Stock productAvailability={productAvailability} />
            </div>
        </div>
    );
};
